var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossThin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5566 8.61787C28.8807 8.29382 28.8807 7.76703 28.5566 7.44298C28.2326 7.11894 27.7058 7.11894 27.3817 7.44298L17.9994 16.8253L8.61714 7.44298C8.29309 7.11894 7.7663 7.11894 7.44225 7.44298C7.11821 7.76703 7.11821 8.29382 7.44225 8.61787L16.8246 18.0002L7.44225 27.3825C7.11821 27.7065 7.11821 28.2333 7.44225 28.5574C7.60509 28.7202 7.81778 28.7999 8.03055 28.7999C8.24331 28.7999 8.45593 28.7185 8.61884 28.5574L18.0011 19.1751L27.3835 28.5574C27.5463 28.7202 27.759 28.7999 27.9717 28.7999C28.1845 28.7999 28.3971 28.7185 28.56 28.5574C28.8841 28.2333 28.8841 27.7065 28.56 27.3825L19.1777 18.0002L28.5566 8.61787Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossThin);
export default __webpack_public_path__ + "static/media/cross-thin.77b70a71ba53c21d61b5a7832007bd76.svg";
export { ForwardRef as ReactComponent };